import React from 'react';
import { Link } from 'react-router-dom';
import PasswordResetForm from 'components/authentication/PasswordResetForm';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { useTranslation } from 'react-i18next';

const PasswordReset = () => {
  const { t } = useTranslation('user');
  return (
    <AuthCardLayout
      leftSideContent={
        <p className="text-white">
          <Link className="text-white text-decoration-underline" to="/">
            {t('Take me home')}
          </Link>
        </p>
      }
    >
      <h3>{t('Reset password')}</h3>
      <PasswordResetForm layout="card" hasLabel />
    </AuthCardLayout>
  );
};

export default PasswordReset;
